export default __webpack_public_path__ + "static/media/ae-logo-light-nameonly.fd90a80f.png";